import axios from "axios";
import react from "react";
import Cookies from 'js-cookie';

import { useSearchParams } from "react-router-dom";
import { useShoppingCart } from "../../context/CartContext.tsx/ShoppingCartContext";
import useCookies from "react-cookie/cjs/useCookies";

interface Params {
  baseUrl: string;
  headers: any;
  method: string;
}

const apiURL: any = process.env.REACT_APP_API_URL;
const apiURL2: any = process.env.REACT_APP_API_URL_2;


const cookieValue = Cookies.get('cookieName');
const getTokenFromURL = () =>  {
  const urlParams = new URLSearchParams(window.location.search);
  let token = null;
  if(urlParams.has('token')){
    token = urlParams.get("token");
  }
  return token;
};
//let bearerToken = null;
const bearerData = () =>{
  let bearerToken = null;
  bearerToken = getTokenFromURL();
  if( bearerToken == null){
    bearerToken = cookieValue;
  }
  return bearerToken;
};

// For get request
// for cart get cart only
export const getAPICart = async (url: string): Promise<any> => {
  const getConfig: Params = {
    baseUrl: apiURL2,
    headers: {
      Authorization: `Bearer ${bearerData()}`,
    },
    method: "get",
  };
  return await axios({
    ...getConfig,
    url: `${getConfig.baseUrl}/${url}`,
  })
    .then((response) => {
      //   console.log(response);
      return response.data;
    })
    .catch((error) => {
      // console.log(error);
      return error;
    });
};



  export const getAPI = async (url: string, data: any): Promise<any> => {
    const getConfig: Params = {
      baseUrl: apiURL,
      headers: {
        Authorization: `Bearer ${bearerData()}`,
      },
      method: "get",
    };
    return await axios({
      ...getConfig,
      url: `${getConfig.baseUrl}/${url}/${data}`,
    })
      .then((response) => {
        //   console.log(response);
        return response.data;
      })
      .catch((error) => {
        // console.log(error);
        return error;
      });
  };


// For get API without payload

export const getAPIData = async (url: string): Promise<any> => {
  const getConfig: Params = {
    baseUrl: apiURL,
    headers: {
      Authorization: `Bearer ${bearerData()}`,
    },
    method: "get",
  };
  return await axios({
    ...getConfig,
    url: `${getConfig.baseUrl}/${url}`,
  })
    .then((response) => {
      // console.log(response, "656576658768");
      return response.data;
    })
    .catch((error) => {
      // console.log(error);
      return error;
    });
};

// For post request

export const postAPI = async (url: string, payload: any): Promise<any> => {

  const postConfig: Params = {
    baseUrl: apiURL,
    headers: {
      Authorization: `Bearer ${bearerData()}`,
    },
    method: "post",
  };
  return await axios({
    ...postConfig,
    data: payload,
    url: `${postConfig.baseUrl}/${url}`,
  })
    .then((response) => {
      //   console.log(response);
      // return response;
      return response.data;
    })
    .catch((error) => {
      // console.log(error);
      return error;
    });
};


// new version apis function wihtout payload
export const getAPIV2 = async (url: string): Promise<any> => {
  const getConfig: Params = {
    baseUrl: apiURL,
    headers: {
      Authorization: `Bearer ${bearerData()}`,
    },
    method: "get",
  };
  return await axios({
    ...getConfig,
    url: `${getConfig.baseUrl}/${url}`,
  })
    .then((response) => {
      //   console.log(response);
      return response.data;
    })
    .catch((error) => {
      // console.log(error);
      return error;
    });
};
